// extracted by mini-css-extract-plugin
module.exports = {"fileStatusContainer":"revenueDcbFileHistory_fileStatusContainer__2FGDx","loadMoreBtnContainer":"revenueDcbFileHistory_loadMoreBtnContainer__2PApa"};